// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"532":"styles","2143":"app"}[chunkId] || chunkId) + "." + {"532":"ddcf74634e1757f7aa2d","2143":"9c7cf3a3fc97fac570b4","5800":"9c651b944de1f7b3788e"}[chunkId] + ".css";
};